import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { helper } from 'src/environments/helper';
import { UpdateTipurTaxeNedebitabileInterface } from './tipuri-taxe-nedebitabile.interface';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { EditTipuriTaxeNedebitateComponent } from './edit-tipuri-taxe-nedebitate/edit-tipuri-taxe-nedebitate.component';
import { TipuriTaxeNedebitabileService } from './tipuri-taxe-nedebitabile.service';
import { PermissionsService } from 'src/app/services/permissions.service';
@Component({
    selector: 'app-tipuri-taxe-nedebitate',
    templateUrl: './tipuri-taxe-nedebitate.component.html',
    styleUrls: ['./tipuri-taxe-nedebitate.component.scss'],
})
export class TipuriTaxeNedebitateComponent
    implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;
    isLoading = false;
    selectedSection: string = '';

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();

    dtLink =
        environment.interop.basePath +
        environment.interop.payments.nomenclatoare.tipuriTaxeNedebitabile
            .getTipuriTaxeNedebitabileDT;

    dataTablesParameters: any = {
        data: {
            key: 'parameter',
        },
    };

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private tipuriTaxeService: TipuriTaxeNedebitabileService,
        private permissionsService: PermissionsService
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true, // Set the flag
            responsive: true,
            searching: false,
            pageLength: 100,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Taxă ID',
                    data: 'tipTaxaId',

                },
                {
                    title: 'Taxă',
                    // data: 'web_name',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return `
                            <span><strong>Denumire:</strong> ` + data.web_name + `</span><br/>
                            <span><strong>Obs.:</strong> ` + data.observatii + `</span>
                        `
                    }
                },
                {
                    title: 'Cont IBAN',
                    data: 'contIBAN',
                },
                { title: 'Valoare', data: 'valoareImplicita' },
                {
                    title: 'Necesită sumă?',
                    data: null,
                    render: (data: any) => {
                        return `
                            <div>${data.necesita_suma_de_introdus == 1 ? 'DA' : 'NU'}</div>
                        `;
                    },
                },

                {
                    title: 'Acțiuni',
                    data: null,
                    orderable: false,
                    className: 'all',
                    render: (data: any, type: any, row: any, met: any) => {
                        return (`
                            <button class="action-btn edit ms-1">
                                <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
                            </button>
                            <button type="button" class="action-btn update_status_active ms-1 ` + (data.active == 1 ? 'action-success' : 'action-danger') + `">
                                <img class="btn-img" src="` + (data.active == 1 ? '/assets/icons/check-white.svg' : '/assets/icons/close-white.svg') + `" alt="update_status_active"/>
                            </button>
                        `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const updateStatusActiveIcon = lastTd?.querySelector(
                    '.update_status_active'
                ) as HTMLElement;
                if (editIcon) {
                    if (!this.permissionsService.hasPermission('payments-module.settings.tipuri-taxe-nedebitate.edit')) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }
                if (updateStatusActiveIcon) {
                    if (!this.permissionsService.hasPermission('payments-module.settings.tipuri-taxe-nedebitate.update-status')) {
                        updateStatusActiveIcon.style.display = 'none';
                    }
                    updateStatusActiveIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.changeStatusActive(id);
                    });
                }

                return row;
            },
        };
    }

    changeStatusActive(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să actualizați statusul înregistrării!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.changeStatusActiveAction(id);
            }
        });
    }

    changeStatusActiveAction(id: number) {
        this.isLoading = true;
        this.tipuriTaxeService.changeStatusActive(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Statusul înregistrării actualizat cu succes',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err: { error: { errors: { message: any[] } } }) => {
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.changeStatusActiveAction(id);
                    }
                });
            }
        );
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
    }

    openEditDialog(data: UpdateTipurTaxeNedebitabileInterface) {
        const dialogRef = this.dialog.open(EditTipuriTaxeNedebitateComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Actualizare cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }
}
